import React from 'react';
import Navigation from './Navigation';
import CurrentView from './CurrentView';
import WeekView from './WeekView';
import MonthView from './MonthView';
import './App.css';

export default class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = { page: 'current' };
		this.handleNavigation = this.handleNavigation.bind(this);

		const hash = document.location.hash.substring(1);
		const [page, selected] = hash.split('/');
		console.log(hash, page);
		if (page && (page === 'current' || page === 'week' || page === 'month')) {
			this.state.page = page;
		}
		if (selected) {
			this.state.selected = selected;
		}

		const params = (new URL(document.location)).searchParams;
		const queryStringTheme = params.get('theme') || 'utherverse';
		queryStringTheme && document.body.classList.add(queryStringTheme);

		const uvCompatible = params.get('uv-compatible') || '0';
		uvCompatible === '1' && document.documentElement.classList.add('uv-compatible');

		this.state.mode = uvCompatible;
	}

	handleNavigation(page) {
		this.setState({ page });
	}

	render() {
		return(
			<div className="App">
				<Navigation mode={this.state.mode} handleNavigation={this.handleNavigation} active={this.state.page} />
				{this.state.page === 'current' 
				? <CurrentView mode={this.state.mode} /> : this.state.page === 'week'
				? <WeekView selected={this.state.selected} mode={this.state.mode} /> : this.state.page === 'month'
				? <MonthView selected={this.state.selected} mode={this.state.mode} /> : null}
			</div>
		);
	}
}
